export default __webpack_public_path__ + "static/media/trash-bin.inline.24ed0fbc.svg";